<template>
  <div class="flex w-full justify-between items-center" :class="{ 'mb-3': isTitle || btnPos == 'top' }">
    <div class="max-md:px-5 max-md:pt-5" v-if="isTitle">
      <p>Add suite to your worksheet:</p>
    </div>
    <div v-if="btnPos == 'top'"
      class="max-md:fixed max-md:bottom-0 max-md:w-full gap-4 max-md:px-9 max-md:border-t max-md:border-mainBlack-300 max-md:bg-white box-border max-md:py-5 max-md:flex max-md:justify-end max-md:items-center z-150">
      <button class="underline md:mr-6" @click="$emit('close')">Cancel</button>
      <button class="bg-mainBlack-1000 rounded-[30px] text-white py-3 px-11" @click="$emit('save', worksheetId)">
        Save
      </button>
    </div>
  </div>
  <div class="max-md:px-5 w-full">
    <popupHeader v-if="floorplanList.length" :models="floorplanList" @handleCheckboxChange="handleCheckboxChange"
      @filterModels="getFilteredData" @handleSortType="getSortType" @handleSortStyle="getSortStyle">
    </popupHeader>
  </div>
  <div class="flex max-md:px-5 flex-wrap mt-9 mb-6 gap-4" :class="classSelection">
    <p class="mr-2 text-mainBlack-400">Selection:</p>
    <div class="flex gap-2" v-for="(item, index) in worksheetId" :key="index">
      <img src="@/assets/icons/svg/worksheet/delete.svg" class="cursor-pointer" @click="deleteUnit(item)" />
      <p class="">Suite {{ item.name }}</p>
      <p class="pl-2 text-mainBlack-300" v-if="index !== worksheetId.length - 1">
        |
      </p>
    </div>
  </div>
  <div class="max-md:px-5 max-md:pb-28 floorplans tablePopupWorksheet mt-3 pb-6">
    <div data-v-d197af3e="" class="vgt-wrap sm:mx-0 mx-auto w-full">
      <div class="vgt-inner-wrap max-md:hidden">
        <div
          class="vgt-responsive !pt-0 h-[68vh] md:h-[calc(100vh_-_20.5rem)] hide-scrollbar !overflow-x-auto !overflow-auto">
          <table id="vgt-table" class="vgt-table bordered !border-spacing-0 h-fit">
            <colgroup>
              <col id="col-0" />
              <col id="col-1" />
              <col id="col-2" />
              <col id="col-3" />
              <col id="col-4" />
              <col id="col-5" />
              <col id="col-6" />
              <col id="col-7" />
              <col id="col-8" />
            </colgroup>
            <thead class="">
              <tr class="">
                <th scope="col" class="webkit-sticky !sticky !bg-qooWhite-5 !rounded-none -top-px vgt-left-align !py-4"
                  aria-sort="descending" aria-controls="col-8" style="min-width: auto; width: auto">
                  <span></span>
                </th>
                <th scope="col" class="webkit-sticky !sticky !bg-qooWhite-5 -top-px vgt-left-align !py-4"
                  aria-sort="descending" aria-controls="col-0" style="min-width: auto; width: auto">
                  <span>Model</span>
                </th>
                <th scope="col" class="webkit-sticky !sticky !bg-qooWhite-5 -top-px vgt-left-align"
                  aria-sort="descending" aria-controls="col-1" style="min-width: auto; width: auto">
                  <span>Type</span>
                </th>
                <th scope="col" class="webkit-sticky !sticky !bg-qooWhite-5 -top-px vgt-left-align"
                  aria-sort="descending" aria-controls="col-2" style="min-width: auto; width: auto">
                  <span>Area</span>
                </th>
                <th scope="col" class="webkit-sticky !sticky !bg-qooWhite-5 -top-px vgt-left-align"
                  aria-sort="descending" aria-controls="col-3" style="min-width: auto; width: auto">
                  <span>Bathrooms</span>
                </th>
                <th scope="col" class="webkit-sticky !sticky !bg-qooWhite-5 -top-px vgt-left-align"
                  aria-sort="descending" aria-controls="col-5" style="min-width: auto; width: auto">
                  <span>Price</span>
                </th>
                <th scope="col" class="webkit-sticky !sticky !bg-qooWhite-5 !rounded-none -top-px vgt-left-align"
                  aria-sort="descending" aria-controls="col-7" style="min-width: auto; width: auto">
                  <span>Availability</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(item, index) in filteredModels" :key="index">
                <tr :class="{ 'change-bg': p.selected > -1 && index !== p.selected }">
                  <td class="vgt-left-align !py-6 !pl-8 transition-all ease-in duration-200"
                    :class="{ '!rounded-bl-none': index === p.selected }">
                    <span data-v-d197af3e="" @click="$emit('showDet', index)" class="cursor-pointer">
                      <img class="max-w-none" src="@/assets/icons/svg/worksheet/PlusTable.svg"
                        v-if="index !== p.selected" />
                      <img src="@/assets/icons/svg/worksheet/Plus.svg" v-if="index === p.selected" />
                    </span>
                  </td>
                  <td class="vgt-left-align !py-6">
                    <span data-v-d197af3e="">{{ item.model_name || "-" }}</span>
                  </td>
                  <td class="vgt-left-align !py-6">
                    <span data-v-d197af3e="">{{
                      item.suite_style || "-"
                    }}</span>
                  </td>
                  <td class="vgt-left-align !py-6">
                    <span data-v-d197af3e="">{{ item.area || "-" }}</span>
                  </td>
                  <td class="vgt-left-align !py-6">
                    <span data-v-d197af3e="">{{ item.bathroom || "-" }}</span>
                  </td>
                  <td class="vgt-left-align !py-6">
                    <span data-v-d197af3e="">
                      {{
                        item?.initial_price?.toLocaleString("en-CA", {
                          style: "currency",
                          currency: "CAD",
                        }) || "-"
                      }}</span>
                    <!-- <span>-</span> -->
                  </td>
                  <td class="vgt-left-align !py-6 !justify-start"
                    :class="{ '!rounded-br-none ': index === p.selected }">
                    <span data-v-d197af3e="">
                      {{ item.units.length }}
                    </span>
                  </td>
                </tr>
                <tr class="!w-full !border-t !border-qooWhite-60">
                  <td colspan="100%" class="!pt-0 !pb-0 !table-cell !rounded-[10px] !rounded-t-none">
                    <transition
                      @enter="enter"
                      @leave="leave"
                      :css="false"
                    >
                      <div v-if="index === p.selected" class="grid pb-4 sm:grid-cols-2 grid-cols-2 gap-2 flex-wrap !pt-4 !border-t !border-qooWhite-2">
                        <div class="bg-qooWhite-5 rounded-lg px-2 py-3 w-full" v-for="(i, j) in item.units"
                          :key="j + '-unit'">
                          <div class="flex gap-2 justify-between">
                            <ul class="flex 3xl:grid !p-0 3xl:grid-cols-3 items-center w-[calc(100%-127px)] justify-between flex-wrap gap-2">
                              <li>
                                <div class="text-xs text-mainBlack-300">Suite:</div>
                                <div class="text-sm">{{ i.name }}</div>
                              </li>
                              <li>
                                <div class="text-xs text-mainBlack-300">
                                  Orientation:
                                </div>
                                <div class="text-sm">{{ i.exposure }}</div>
                              </li>
                              <li>
                                <div class="text-xs text-mainBlack-300">Price:</div>
                                <div class="text-sm">
                                  {{
                                    i.price?.toLocaleString("en-US")
                                      ? "$" + i.price?.toLocaleString("en-US")
                                      : "-"
                                  }}
                                </div>
                              </li>
                              
                            </ul>
                            <div class="!w-[127px] flex justify-end items-center">
                              <EnhancedButton
                                :disabled="i.status == 'Sold'"
                                type="outlined"
                                @clickBtn="addWSH(item.id, i.id)"
                                classList="!px-4 !py-2 h-fit"
                                :text="worksheetId.findIndex(
                                  (worksheet) =>
                                    worksheet.Mid === item.id &&
                                    worksheet.Uid === i.id,
                                ) == -1
                                    ? 'Add Suite'
                                    : 'Remove Suite'
                                  ">
                              </EnhancedButton>
                            </div>
                          </div>
                          
                        </div>
                      </div>
                    </transition>
                  </td>
                </tr>
                <tr>
                  <th class="!p-1"></th>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
      <div
        class="md:hidden card bg-qooWhite-5 border flex flex-col gap-2 h-[calc(100vh_-_19.5rem)] hide-scrollbar overflow-auto border-qooWhite-2 rounded-xl p-3">
        <div class="bg-white rounded-xl px-6 py-4" :class="{ 'change-bg': p.selected > -1 && index !== p.selected }"
          v-for="(item, index) in filteredModels" :key="index">
          <div class="mt-0 flex flex-col w-full items-start justify-between gap-5">
            <div class="flex w-full items-center justify-between">
              <div class="flex gap-2 transition-all ease-in duration-200"
                :class="{ '!rounded-bl-none': index === p.selected }">
                <span data-v-d197af3e="" @click="$emit('showDet', index)" class="cursor-pointer">
                  <img src="@/assets/icons/svg/worksheet/PlusTable.svg" v-if="index !== p.selected" />
                  <img src="@/assets/icons/svg/worksheet/Plus.svg" v-if="index === p.selected" />
                </span>
                <span data-v-d197af3e="">{{ item.model_name || "-" }}</span>
              </div>
              <div>
                <p>{{ item.availability || "-" }} available suites</p>
              </div>
            </div>
            <div class="mt-3.5 flex w-full items-stretch justify-between gap-1">
              <div class="flex w-1/2 flex-col items-stretch">
                <div class="text-sm text-mainBlack-300">Type</div>
                <div class="mt-0 whitespace-nowrap text-base text-black">
                  {{ item.suite_style || "-" }}
                </div>

                <div class="mt-6 text-sm text-mainBlack-300">Bathrooms</div>
                <div class="mt-0 text-base text-black">
                  {{ item.bathroom || "-" }}
                </div>
              </div>
              <div class="flex w-1/2 flex-col items-stretch">
                <div class="text-sm text-mainBlack-300">Area</div>
                <div class="mt-0 whitespace-nowrap text-base text-black">
                  {{ item.area || "-" }}
                </div>

                <div class="mt-6 text-sm text-mainBlack-300">Price</div>
                <div class="mt-0 text-base text-black">
                  {{
                    item?.initial_price?.toLocaleString("en-CA", {
                      style: "currency",
                      currency: "CAD",
                    }) || "-"
                  }}
                </div>
                <!-- <div class="mt-0 text-base text-black">-</div> -->
              </div>
            </div>
          </div>
          <div v-if="index === p.selected" class="!w-full !border-t !border-qooWhite-60 mt-3">
            <div class="!pt-0 w-full !rounded-[10px] !rounded-t-none">
              <div class="grid w-full grid-cols-1 gap-2 flex-wrap !pt-4 !border-t !border-qooWhite-2">
                <div class="bg-qooWhite-5 rounded-lg px-2 py-3 w-full" v-for="(i, j) in item.units" :key="j + '-unit'">
                  <ul class="flex items-center justify-between flex-wrap">
                    <li>
                      <div class="text-xs text-mainBlack-300">Suite:</div>
                      <div class="text-sm">{{ i.name }}</div>
                    </li>
                    <li>
                      <div class="text-xs text-mainBlack-300">Orientation:</div>
                      <div class="text-sm">{{ i.exposure }}</div>
                    </li>
                    <li>
                      <div class="text-xs text-mainBlack-300">Price:</div>
                      <div class="text-sm">
                        {{
                          item.price?.toLocaleString("en-US")
                            ? "$" + item.price?.toLocaleString("en-US")
                            : "-"
                        }}
                        <!-- - -->
                      </div>
                    </li>
                    <li class="min-w-[105px] text-center">
                      <EnhancedButton
                        @clickBtn="addWSH(item.id, i.id)"
                        classList="px-4 py-2 w-full text-center"
                        :text="worksheetId.findIndex(
                          (worksheet) =>
                            worksheet.Mid === item.id &&
                            worksheet.Uid === i.id,
                        ) == -1
                            ? 'Add Suite'
                            : 'Remove Suite'
                          ">
                      </EnhancedButton>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="flex w-full justify-end mt-0">
    <div v-if="btnPos != 'top'"
      class="max-md:fixed max-md:bottom-0 max-md:w-full gap-4 max-md:px-9 max-md:border-t max-md:border-mainBlack-300 max-md:bg-white box-border max-md:py-5 max-md:flex max-md:justify-end max-md:items-center z-150">
      <button class="underline md:mr-6" @click="$emit('close')">Cancel</button>
      <button class="bg-mainBlack-1000 rounded-[30px] text-white py-3 px-11" @click="$emit('save', worksheetId)">
        Save
      </button>
    </div>
  </div>
</template>

<!-- eslint-disable no-undef -->
<script setup>
import EnhancedButton from "@/components/base/common/EnhancedButton.vue";
import popupHeader from "./popupHeader.vue";
import { ref, onMounted } from "vue";
import { useModels } from "@/store/models.js";
import { showToast } from "@/util/toast";
import gsap from 'gsap';

let modelsStore = {};
const filteredModels = ref([]);
const sortStyle = ref("Asc");
const sortType = ref("Name");

const p = defineProps({
  floorplanList: {
    type: Array,
  },
  isTitle: {
    type: Boolean,
    default: true,
  },
  classSelection: {
    type: String,
    default: "",
  },
  btnPos: {
    type: String,
    default: "top",
  },
  selected: {
    type: Number,
    default: -1,
  },
  worksheetList: {
    type: Array,
  },
});

const worksheetId = ref([]);

const addWSH = (Mid, Uid) => {
  if (
    worksheetId.value.length < 3 ||
    worksheetId.value.findIndex(
      (worksheet) => worksheet.Mid === Mid && worksheet.Uid === Uid,
    ) !== -1
  ) {
    const index = worksheetId.value.findIndex(
      (worksheet) => worksheet.Mid === Mid && worksheet.Uid === Uid,
    );
    if (index !== -1) {
      worksheetId.value.splice(index, 1);
    } else {
      let newWorksheet = {};
      p.floorplanList.forEach((element) => {
        if (element.id === Mid) {
          element.units.forEach((e) => {
            if (e.id === Uid) {
              newWorksheet = {
                Mid: element.id,
                order: worksheetId.value.length - 1,
                Uid: e.id,
                model_name: element.model_name,
                name: e.name,
                type: element.suite_style,
                price: e.price,
                area: element.area,
                bathroom: element.bathroom,
                exposure: e.exposure,
              };
            }
          });
        }
      });
      worksheetId.value.push(newWorksheet);
    }
  } else
    showToast({
      message: "The maximum number of suites allowed is 3",
      type: "error",
    });
};
const deleteUnit = (data) => {
  const index = worksheetId.value.findIndex((item) => item.Uid === data.Uid);
  if (index !== -1) {
    worksheetId.value.splice(index, 1);
  }
  return worksheetId.value;
};

defineEmits(["showDet", "close", "save"]);

const handleCheckboxChange = (e) => {
  showTable.value = e;
};

const getSortType = (e) => {
  sortType.value = e ? "Size" : "Name";
  sortModelsList();
};

const getSortStyle = (e) => {
  sortStyle.value = e ? "Desc" : "Asc";
  sortModelsList();
};

const sortModelsList = () => {
  const compare = (a, b) => {
    if (sortType.value === "Name") {
      const nameA = a.model_name.toLowerCase();
      const nameB = b.model_name.toLowerCase();

      return sortStyle.value === "Asc"
        ? nameA.localeCompare(nameB)
        : nameB.localeCompare(nameA);
    } else if (sortType.value === "Size") {
      return sortStyle.value === "Asc" ? a.area - b.area : b.area - a.area;
    }
  };

  filteredModels.value.sort(compare);
};

const getFilteredData = (models) => {
  filteredModels.value = models;
  modelsStore.setFilteredData(filteredModels.value);
  sortModelsList();
};

const enter = (el, done) => {
  gsap.from(el, {
    height: 0,
    opacity: 0,
    duration: 0.5,
    onComplete: done,
    ease: 'power2.inOut'
  });
};

const leave = (el, done) => {
  gsap.to(el, {
    height: 0,
    opacity: 0,
    duration: 0.5,
    onComplete: done,
    ease: 'power2.inOut'
  });
};

onMounted(() => {
  modelsStore = useModels();

  worksheetId.value = [] //JSON.parse(JSON.stringify(p.worksheetList));
  p.worksheetList.forEach((value, index, array) => {
    let newWorksheet = {};
    p.floorplanList.forEach((element) => {
      if (element.id === value.Mid) {
        element.units.forEach((e) => {
          if (e.id === value.Uid) {
            newWorksheet = {
              Mid: element.id,
              order: worksheetId.value.length - 1,
              Uid: e.id,
              model_name: element.model_name,
              name: e.name,
              type: element.suite_style,
              price: e.price,
              area: element.area,
              bathroom: element.bathroom,
              exposure: e.exposure,
            };
          }
        });
      }
    });
    worksheetId.value.push(newWorksheet);
  })

});
</script>

<style lang="scss" scoped>
@keyframes slideIn {
  0% {
    width: 200px;
    height: 60px;
  }

  100% {
    width: 384px;
    height: 50vh;
  }
}

@keyframes slideOut {
  0% {
    width: 384px;
    height: 50vh;
    display: block;
  }

  100% {
    width: 200px;
    height: 60px;
    display: none;
  }
}

.slideOut {
  display: none;
}

.filter-container {
  animation-duration: 0.5s;
  animation-timing-function: ease-in-out;
}

.filter-container.slideIn {
  animation-name: slideIn;
}

.filter-container.slideOut {
  animation-name: slideOut;
}

.change-bg {
  td {
    // background-color: rgba(246, 246, 246) !important;
    // color: ;
    opacity: 50%;
  }
}

.card {
  .change-bg {
    opacity: 50%;
  }
}

.floorplans.tablePopupWorksheet .vgt-responsive {
  overflow-x: auto !important;
}

.tablePopupWorksheet table.vgt-table td.\!pb-0 {
  padding-bottom: 0 !important;
}
</style>
